import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function VerifyStartPage() {
  const { guildId } = useParams();

  useEffect(() => {
    if (!guildId || !API_BASE) return;
    window.location.replace(
      `${API_BASE}/verify/start?guildId=${encodeURIComponent(guildId)}`,
    );
  }, [guildId]);

  return (
    <div className="legal-page" style={{ maxWidth: 520, margin: "80px auto" }}>
      <h1>☾ Verifying…</h1>
      <p>Redirecting you to Discord to confirm your account.</p>
    </div>
  );
}
